/* Casa de Diciembre · Ficha de producto
   - Selector de pack (radios name="cdd-pack", fuera del <form>): actualiza input[name=id],
     precio, barra fija y ?variant= (history.replaceState).
   - Galería: cambia la foto principal sin recargar.
   - Línea de entrega en días laborables (L-V) y fecha límite para el 1 de diciembre.
   - Estado «Añadido al carrito ✓» 1,8 s. El POST y la apertura del cajón los hace el
     <product-form> de Shrine (main.js): no se duplica aquí.
   Se carga desde varias secciones: el guardián evita doble inicialización. */
(function () {
  if (window.__cddProduct) return;
  window.__cddProduct = true;

  var ADDED_MS = 1800;

  function eur(cents) {
    return (Number(cents) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function isWorkday(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addBD(d, n) {
    var x = new Date(d.getTime()), k = 0;
    while (k < n) { x.setDate(x.getDate() + 1); if (isWorkday(x)) k++; }
    return x;
  }
  function subBD(d, n) {
    var x = new Date(d.getTime()), k = 0;
    while (k < n) { x.setDate(x.getDate() - 1); if (isWorkday(x)) k++; }
    return x;
  }
  function fShort(d) {
    return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace(/\./g, '');
  }
  function fLong(d) {
    return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
  }
  function num(v, def) { var n = parseInt(v, 10); return isNaN(n) ? def : n; }

  /* ---------- Línea de entrega ---------- */
  function renderTimeline(root) {
    var tl = root.querySelector('[data-cdd-timeline]');
    if (!tl) return;
    var sMin = num(root.dataset.shipMin, 1), sMax = num(root.dataset.shipMax, 2);
    var aMin = num(root.dataset.arriveMin, 6), aMax = num(root.dataset.arriveMax, 10);
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var d1 = tl.querySelector('[data-cdd-d1]'), d2 = tl.querySelector('[data-cdd-d2]'), d3 = tl.querySelector('[data-cdd-d3]');
    if (d1) d1.textContent = fShort(today);
    if (d2) d2.textContent = fShort(addBD(today, sMin)) + ' – ' + fShort(addBD(today, sMax));
    if (d3) d3.textContent = fShort(addBD(today, aMin)) + ' – ' + fShort(addBD(today, aMax));

    var dl = root.querySelector('[data-cdd-deadline]');
    if (!dl) return;
    if (root.dataset.deadline === 'false') { dl.hidden = true; return; }
    var adv = new Date(today.getFullYear(), 11, 1);
    var lim = subBD(adv, aMax);
    if (today.getTime() <= lim.getTime()) {
      dl.innerHTML = 'Pide antes del <b>' + fLong(lim) + '</b> y lo recibes antes del 1 de diciembre.';
      dl.hidden = false;
    } else {
      dl.hidden = true;
    }
  }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-cdd-main-img]');
    var thumbs = root.querySelectorAll('[data-cdd-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-pressed') === 'true') return;
        main.removeAttribute('fetchpriority');
        if (btn.dataset.srcset) main.setAttribute('srcset', btn.dataset.srcset);
        main.setAttribute('src', btn.dataset.src);
        main.setAttribute('alt', btn.dataset.alt || '');
        thumbs.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- Packs / variantes ---------- */
  function initPacks(root, sticky) {
    var form = document.getElementById(root.dataset.form);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = root.querySelector('[data-cdd-price]');
    var radios = root.querySelectorAll('input[name="cdd-pack"]');
    var stickyPrice = sticky ? sticky.querySelector('[data-cdd-sticky-price]') : null;
    var stickyNote = sticky ? sticky.querySelector('[data-cdd-sticky-note]') : null;

    function apply(r, updateUrl) {
      if (idInput) idInput.value = r.value;
      var price = eur(r.dataset.price);
      if (priceEl) priceEl.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyNote) stickyNote.textContent = (stickyNote.dataset.short || '') + ' · ' + (r.dataset.title || '');
      radios.forEach(function (x) {
        var label = x.closest('.cdd-pack');
        if (label) label.classList.toggle('is-checked', x === r);
      });
      if (updateUrl && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* noop */ }
      }
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) apply(r, true); });
    });
    // Sincroniza si el navegador restauró otro radio (volver atrás / bfcache)
    var checked = root.querySelector('input[name="cdd-pack"]:checked');
    if (checked && idInput && idInput.value !== checked.value) apply(checked, false);
  }

  /* ---------- Barra fija móvil ---------- */
  function placeSticky(root) {
    var sticky = root.querySelector('[data-cdd-sticky]');
    var mainEl = document.getElementById('MainContent') || document.querySelector('main');
    if (!sticky || !mainEl) return sticky;
    mainEl.querySelectorAll(':scope > .cdd-sticky[data-section="' + root.dataset.section + '"]').forEach(function (old) {
      if (old !== sticky) old.remove();
    });
    mainEl.appendChild(sticky);
    return sticky;
  }

  function initProduct(root) {
    if (!root || root.dataset.cddReady === '1') return;
    root.dataset.cddReady = '1';
    var sticky = placeSticky(root);
    initGallery(root);
    initPacks(root, sticky);
    renderTimeline(root);
  }

  /* ---------- «Añadido al carrito ✓» ---------- */
  var pending = null; // { form, buttons }

  function markAdded(buttons) {
    buttons.forEach(function (btn) {
      if (!btn) return;
      if (btn.dataset.cddLabel === undefined) btn.dataset.cddLabel = btn.innerHTML;
      clearTimeout(btn._cddT);
      btn.textContent = 'Añadido al carrito ✓';
      btn.classList.add('cdd-btn--added');
      btn._cddT = setTimeout(function () {
        btn.innerHTML = btn.dataset.cddLabel;
        delete btn.dataset.cddLabel;
        btn.classList.remove('cdd-btn--added');
      }, ADDED_MS);
    });
  }

  function initForms(scope) {
    (scope || document).querySelectorAll('product-form[data-cdd-form]').forEach(function (pf) {
      var form = pf.querySelector('form');
      if (!form || form.dataset.cddBound === '1') return;
      form.dataset.cddBound = '1';
      form.addEventListener('submit', function (e) {
        var main = pf.querySelector('[data-cdd-add]');
        var btns = [main];
        if (e.submitter && e.submitter !== main) btns.push(e.submitter);
        pending = { form: form, buttons: btns };
      });
    });
  }

  var subscribed = false;
  function subscribeCart() {
    if (subscribed) return;
    if (typeof window.subscribe !== 'function' && typeof subscribe !== 'function') return;
    var sub = typeof subscribe === 'function' ? subscribe : window.subscribe;
    var EV = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
    sub(EV, function (data) {
      if (!pending) return;
      if (data && data.source && data.source !== 'product-form') return;
      var p = pending; pending = null;
      markAdded(p.buttons);
    });
    subscribed = true;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cdd-product]').forEach(initProduct);
    initForms(scope);
    subscribeCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // main.js también es defer: por si aún no había definido subscribe
  window.addEventListener('load', subscribeCart);

  // Editor de temas
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
